import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Link from '@material-ui/core/Link';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import React, { useState } from 'react';

const PreliminaryFloodplainModal: React.FC = () => {
  const [isOpen, setIsOpen] = useState(true);

  const close = () => setIsOpen(false);

  return (
    <Dialog open={isOpen} disableBackdropClick disableEscapeKeyDown>
      <DialogContent>
        <DialogContentText variant="subtitle1" color="textPrimary">
          The floodplains presented are not yet effective and currently preliminary.
        </DialogContentText>
        <DialogContentText variant="subtitle1" color="textPrimary">
          While we believe the prelimary data offers the most current representation of potential
          flooding in Jefferson County, preliminary data are for review and guidance purposes only.
          By viewing preliminary data and maps, the user acknowledges that the information provided
          is preliminary and subject to change. Additionally, preliminary data cannot be used to
          rate flood insurance policies or enforce the Federal mandatory purchase requirement. This
          site will remove preliminary data once effective data are available.
        </DialogContentText>
        <DialogContentText variant="subtitle1">
          <Box display="flex" flexDirection="row" alignItems="center">
            <InfoIcon color="primary" style={{ marginRight: 8 }} />
            <Link
              variant="inherit"
              href="https://hazards.fema.gov/femaportal/prelimdownload"
              target="blank"
            >
              More information on preliminary FEMA products
            </Link>
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="primary">
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PreliminaryFloodplainModal;
